import "./sheetCard.css";

const Spinner = ({ color = "#3498db", size = 28 }) => {
  return (
    <div
      className="spinner"
      style={{
        "--spinner-color": color,
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
};

export default Spinner;
